import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <h2 className="footer-title">Discussion Forum</h2>
        <p className="footer-tagline">Connect. Share. Learn.</p>
        <div className="footer-links">
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/faq">FAQ</Link>
          <Link to="/terms">Terms of Service</Link>
        </div>
        <p className="footer-copy">&copy; {new Date().getFullYear()} Discussion Forum. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
